import React, { useContext, useEffect } from 'react';
import { DataGrid } from '../../../../../components/DataGrid/DataGrid';
import Skeleton from '@material-ui/lab/Skeleton';
import { store as mainStore } from '../../../../../store';
import { localText } from '../../../../../langs/fa/data-grid';
import { store } from './Customers';
import { makeStyles } from '@material-ui/core/styles';
import NoCustomers from './NoCustomers';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../../../utils/i18n';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const CustomersList = () => {
  const classes = useStyles();
  const history = useHistory();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { users, isLoaded, page, search },
    dispatch,
    actions: { fetchingCustomers },
  } = useContext(store);
  const columns = [
    { field: 'firstName', headerName: 'نام', flex: 1 },
    { field: 'lastName', headerName: 'نام‌خانوادگی', flex: 1 },
    { field: 'nationalCode', headerName: 'کدملی', width: 130 },
    { field: 'company', headerName: 'نام‌شرکت', width: 150 },
    { field: 'companyNationalCode', headerName: 'شناسه‌شرکت', width: 150 },
    { field: 'phone', headerName: 'تلفن', width: 150 },
    { field: 'mobilePhone', headerName: 'موبایل', width: 150 },
    { field: 'status', headerName: 'وضعیت', width: 120 },
  ];
  const handlePageChange = async (page) => {
    dispatch({ type: 'CHANGE_PAGE', payload: page });
  };
  const handleSelectOrder = (selection) => {
    const userId = selection.row.id;
    // const [userId] = selection.rowIds;
    // const { role } = users.docs.find((u) => u._id === userId);
    history.push(`/protected/admin/users/customer/${userId}`);
  };

  useEffect(() => {
    if (!page) return;
    (async () => {
      const res = await fetchingCustomers(page, itemsCountPerPage, search);
      dispatch({ type: 'CUSTOMERS', payload: res });
    })();
  }, [page]);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <DataGrid
        rows={
          users && users.docs
            ? users.docs.map((u) => ({
                id: u._id,
                firstName: u.firstName,
                lastName: u.lastName,
                nationalCode: u.nationalCode,
                company: u.company,
                companyNationalCode: u.companyNationalCode,
                phone: u.phone,
                mobilePhone: u.mobilePhone,
                status: __(u.status),
              }))
            : []
        }
        columns={columns}
        localeText={localText}
        pageSize={Number(itemsCountPerPage)}
        rowCount={users && users.totalDocs ? users.totalDocs : 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={!isLoaded}
        disableMultipleSelection
        density="compact"
        components={{
          noRowsOverlay: NoCustomers,
        }}
        // onSelectionChange={handleSelectOrder}

        pageNumber={page * 1}
        onCellClick={handleSelectOrder}
        totalPages={users?.totalPages}
        defaultPage={users?.page}
        footerPagination={true}
      />
    </div>
  );
};

export default React.memo(CustomersList);
